var detail = require('./product/details');
var minicart = require('./components/miniCart');
/**
 * product added to cart when the customer has pressed the "Add to Cart" button
 * @param {string} url - ad to cart url
 * @param {Object} form - product data
 */
function addToBag(url, form) {
    $.ajax({
        url: url,
        type: 'post',
        data: form,
        success: function (response) {
            if (!response.error) {
                detail.handlePostCartAdd(response);
            }
            $('body').trigger('product:afterAddToCart', response);
            detail.miniCartReportingUrl(response.reportingURL);
            if (!response.error || response.maxQty && response.maxQty.error){
                minicart.miniCartShow();
            }
            var trayOpened = false;
            $('body').on('trayModalOpened', function (e, traydata) {
                if (!trayOpened && response.maxQty && response.maxQty.error && traydata.customClassName.includes('mini-cart-tray')) {
                    $('.minicart-maxqty-error').addClass('alert alert-danger p-4');
                    var errorHtml = '<strong class="title mb-1 font-weight-xbold small d-block">' + response.maxQty.message + '</strong>'
                        +'<p class="m-0 small mk-text-color-black">' + response.maxQty.msg + '</p>';
                    $('.minicart-maxqty-error').append(errorHtml);
                    trayOpened = true;
                }
            });
        }
    });
}
window.addEventListener('load', function () {
    const iCatalogUrl = document.querySelector('input[name="iCatalogUrl"]');
    const baseURL = iCatalogUrl ? iCatalogUrl.value : '';
    const allowedDomainsStr = $('.iCatalog-Iframes').attr('data-alloweddomains') || '';
    const allowedDomains = allowedDomainsStr.split(',').map(domain => domain.trim());

    let iCatalogProxy = null;
    let iCatalogHandler = null;

    /**
     * Initialize Porthole proxy and event listener
     */
    function initializeiCatalogProxy() {
        if (typeof Porthole !== 'undefined') {
            if (iCatalogProxy && iCatalogHandler) {
                iCatalogProxy.removeEventListener(iCatalogHandler);
            }

            iCatalogProxy = new Porthole.WindowProxy(baseURL, 'ecatalogiframe'); // eslint-disable-line

            iCatalogHandler = function (event) {
                if (event?.origin === baseURL && event?.data && event.data.includes('addToBag')) {
                    const data = event.data;
                    const params = new URLSearchParams(data);
                    const partIds = params.get("productIds");
                    const url = $('.iCatalog-Iframes').attr('data-add-to-cart-url');

                    if (partIds && url) {
                        const productArray = partIds.split(',');
                        const productCount = {};

                        productArray.forEach(id => {
                            productCount[id] = (productCount[id] || 0) + 1;
                        });

                        Object.entries(productCount).forEach(([pid, quantity]) => {
                            const form = {
                                pid: pid,
                                quantity: quantity
                            };

                            addToBag(url, form);
                        });
                    }
                } else if (event?.origin && allowedDomains.includes(event?.origin) && event?.data && event.data.includes('add_to_cart')) {
                    const eventData = JSON.parse(event.data);
                    const item = eventData.parameters.ecommerce.items[0];
                    const variantId = item.item_variant;
                    const quantity = item.quantity;
                    var url = $('.iCatalog-Iframes').attr('data-add-to-cart-url');
                    var form = {
                        pid: variantId,
                        quantity: quantity
                    };
                    addToBag(url, form);
                }
            };

            iCatalogProxy.addEventListener(iCatalogHandler);
        }
    }

    if (typeof Porthole !== 'undefined') {
        Porthole.WindowProxyDispatcher.start(); // eslint-disable-line
        initializeiCatalogProxy();
    }

    $(document).ready(function () {
        let viewport = document.getElementsByName('viewport')[0];
        viewport.content = "width=device-width,minimum-scale=1.0,maximum-scale=2.0,initial-scale=1.0";
    });
});
